import React, { Component } from 'react';
import commonUtil from '../../../../../utils/commonUtil';
import InputButton from '../../../../../components/ZUILib/InputButton';
import ModalPopover from '../../../../../components/ZUILib/ModalPopover';
// import CheckBox from '../../../../../components/ZUILib/CheckBox';
import RadioButton from '../../../../../components/ZUILib/RadioButton';


class Filter extends Component {
  // state={
  //   clear: false,
  // }
  constructor(props) {
    super(props);
    this.state = {
      category: '',
      sortingType: '',

    };
  }
  showModal = () => {
    this.filterModal.handleShow();
  }
  hidemodal = () => {
    this.filterModal.handleHide();
  }
  sortProductByCat = (selectedCatInfo) => {
    this.props.sortProductByCat(selectedCatInfo);
  };

  getSorting(selectedCatInfo) {
    this.hidemodal();
    if (selectedCatInfo.checked) {
      this.props.sortProductByCat(selectedCatInfo);
    }
  }
  showNextFilter= () => {
    this.first1.style.display = 'block';
    this.first.style.display = 'none';
  }

  handleCategorySelection = (e) => {
    this.filterModal.handleHide();
    document.getElementById('clearFilter').className = 'filterClearButton';
    let category = '';
    if (e.id === 'Ascending' || e.id === 'Descending') {
      // this.priceOrder = e.id;
      this.setState({ sortingType: e.id });
      this.props.getPredeterminedListPageItemsInfo(this.props.repoId, '1', this.state.category, e.id);
    } else {
      this.setState({ category: e.id });
      category = e.id;
      this.props.getPredeterminedListPageItemsInfo(this.props.repoId, '1', category, this.state.sortingType);
    }
    // this.props.getPredeterminedListPageItemsInfo(this.props.repoId, '1', category, this.priceOrder);
    // this.filterModal.handleHide();
    this.first1.style.display = 'none';
    this.first.style.display = 'block';

    // this.first.handleHide();
  }
  clearSelectedValue = () => {
    document.getElementById('clearFilter').className = 'filterCleanButton';
    this.props.getPredeterminedListPageItemsInfo(this.props.repoId, '1');

    const radios = document.getElementsByName('priceBasedSorting');
    for (let i = 0; i < radios.length; ++i) {
      radios[i].checked = false;
      this.setState({ category: '', sortingType: '' });
    }
    const categoryfilters = document.getElementsByName('categoryfilter');
    for (let i = 0; i < categoryfilters.length; ++i) {
      categoryfilters[i].checked = false;
      this.setState({ category: '', sortingType: '' });
    }
  }
  closeCategoryFilterModal =() => {
    this.first1.style.display = 'none';
    this.first.style.display = 'block';
  }
  render() {
    const label = this.props.label;
    const FilterBack = {
      value: commonUtil.getLabel(label.PredeterminedPage, 'predetermined.to.return.by.label'),
      id: 'closeModal',
      autoFocus: false,
      style: 'filterBackButton',
      // iconClass: 'icon-flecha_light_izq',
      onClickHandler: this.closeCategoryFilterModal,
    };

    const FilterClean = {
      id: 'clearFilter',
      value: commonUtil.getLabel(label.PredeterminedPage, 'predetermined.clean.filters.by.label'),
      className: 'filterCleanButton',
      autoFocus: false,
      style: 'filterCleanButton',
      onClickHandler: this.clearSelectedValue,
    };

    const PriceBasedSorting = {
      htmlId: 'priceBasedSorting',
      title: 'priceBasedSorting',
      displayName: 'priceBasedSorting',
      name: 'priceBasedSorting',
      options: [
        {
          id: 'Ascending',
          value: 'lowToHigh',
          title: 'Menor precio',
          displayName: commonUtil.getLabel(label.PredeterminedPage, 'predetermined.lower.price.by.label'),
          labelResourceId: 'Menor precio',
        },
        {
          id: 'Descending',
          value: 'highToLow',
          title: 'Meyor precio',
          displayName: commonUtil.getLabel(label.PredeterminedPage, 'predetermined.best.price.by.label'),
          labelResourceId: 'Meyor precio',
        },
      ],
    };
    const categoryList = this.props.categoryList ? this.props.categoryList : null;

    return (

      <ModalPopover
        dismiss="flase"
        isModal="true" modalClass="mobileGifts" headerData={(
          <div><span className="choosenOption" style={{ display: 'none' }} />
            <table className="tableFilterOptions">
              <tbody><tr className="optionFilter">
                <td>
                  <i className="icon-flecha_light_izq" />
                  <InputButton buttonAttr={FilterBack} />
                </td>
                <td>
                  <InputButton buttonAttr={FilterClean} />
                </td>
              </tr>
              </tbody>
            </table>
          </div>)}
        ref={filterModal => this.filterModal = filterModal}
      >
        <div className="filterDefaultListModal modalContent" style={{ display: 'block' }}>

          <div ref={first => this.first = first} ><p className="textCategory">{commonUtil.getLabel(label.PredeterminedPage, 'predetermine.listpage.price.dropdown.label')}</p>
            <table className="tableFilter radioFilters">
              <tbody>
                {PriceBasedSorting.options.map((option, index) => (
                  <tr className="optionFilter" rel="category">
                    <td> {option.displayName} </td>
                    <td>
                      <div className="radio" key={index}>
                        <RadioButton
                          id={option.id} refs={'rad' + option.id} value={option.value} name={PriceBasedSorting.name}
                          radioCssClass={'radio'} onChangeFunction={this.handleCategorySelection}
                        />
                      </div>
                    </td>
                  </tr>
                   ))}
              </tbody>
            </table>
            <p className="textCategory secondFilter"> {commonUtil.getLabel(label.PredeterminedPage, 'predetermined.clean.filters.by.label')}</p>
            <table className="tableFilter">
              <tbody><tr className="optionFilter categoryModal" onClick={this.showNextFilter}>
                <td style={{ width: '87%' }}>
                  <p className="textCategory" >{commonUtil.getLabel(label.PredeterminedPage, 'predetermine.listpage.categoty.dropdown.label')}</p>
                  <p className="sub" />
                </td>
                <td><i className="icon-flecha_lightsvg_derecha" aria-hidden="true" /></td>
              </tr>
              </tbody></table>
          </div>
        </div>
        <div className="categoryDefaultListModal" ref={first1 => this.first1 = first1} style={{ display: 'none' }}>


          <table className="tableFilter radioFilters">
            <tbody>
              { categoryList ? categoryList.map(data =>

                <tr className="optionFilter" rel="category">
                  <td> {data.displayName} </td>
                  <td>
                    <RadioButton
                      id={data.catId}
                      value={data.catName}
                      name={'categoryfilter'}
                      displayName={data.catName}
                      defaultChecked={data.checked}
                      radioCssClass={'radio'}
                      onChangeFunction={this.handleCategorySelection}
                      {...data}
                    />
                  </td>
                </tr>,
              ) : null}

            </tbody>
          </table>

        </div>


      </ModalPopover>
    );
  }
}
export default Filter;

